import { Injectable } from '@angular/core';
import {
  HttpClient, HttpHeaders, HttpErrorResponse,
  HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpParams, HttpResponse, HttpEventType,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { delay, map, catchError } from 'rxjs/operators';
import { environment } from '../environment/environment';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FileUtils } from '../utils/FIleUtils';

@Injectable({
  providedIn: 'root',
})
// tslint:disable:max-line-length
// tslint:disable:no-console
export class ServerTokenService implements HttpInterceptor {

  constructor(private http: HttpClient, private router:Router) {
    console.log('ServerTokenService constructor')
    FileUtils.server = this;
  }
  base_url = environment.apiUrl + '/'; //  'http://localhost:8080/api/'; // 'https://list-server-api.herokuapp.com/api/';
  authToken: String;

  setAuthToken(token: String) {
    this.authToken = token;
  }
  getOptions(headers?: {}): {} {
    // this.httpOptions.headers.set('x-access-token', this.authService.currentUserSubject.token);
    headers = headers ? headers : {};
    headers['Content-Type'] = 'application/json';
    headers['x-access-token'] = this.authToken || '';
    return {
      headers: new HttpHeaders(headers),
    };
  }

  getWithToken<T>(path: String, headers?: {}): Observable<T> {
    return this.http.get<T>(`${this.base_url}api/` + path, this.getOptions(headers)).pipe(
      catchError((error: HttpErrorResponse) => this.handleErrors(error)),
    );;
  }

  postWithToken<T>(path: String, data: Object, headers?: {}): Observable<T> {
    return this.http.post<T>(`${this.base_url}api/` + path, data, this.getOptions(headers)).pipe(
      catchError((error: HttpErrorResponse) => this.handleErrors(error)),
    );
  }

  putWithToken<T>(path: String, data: Object, headers?: {}): Observable<T> {
    return this.http.put<T>(`${this.base_url}api/` + path, data, this.getOptions(headers)).pipe(
      catchError((error: HttpErrorResponse) => this.handleErrors(error)),
    );;;
  }

  patchWithToken<T>(path: String, data: Object, headers?: {}): Observable<T> {
    return this.http.request<T>('PATCH', `${this.base_url}api/` + path, {
      body: data,
      ...this.getOptions(headers),
    }).pipe(
      catchError((error: HttpErrorResponse) => this.handleErrors(error)),
    );
  }

  deleteWithToken<T>(path: String, data?: Object, headers?: {}): Observable<T> {
    return this.http.delete<T>(`${this.base_url}api/` + path, {body: data, ...this.getOptions(headers)}).pipe(
      catchError((error: HttpErrorResponse) => this.handleErrors(error)),
    );;;
  }

  handleErrors(error: HttpErrorResponse) {
    // never log the response object itself - its url carries the referral id
    console.log('http error', error.status);
    if( error.status === 0){
      // alert('There seems to be a problem with your internet connection, please try again later.');
    }
    // Already on login means the guard sent us here and requests fired before the redirect
    // landed are only now failing. Redirecting again would capture the login url itself as
    // the returnUrl, and isSafeReturnUrl rejects /auth - the real page is lost.
    if (error.status === 401 && !this.router.url.startsWith('/auth')) {
      let ru: string | undefined;
      try {
        const stored = JSON.parse(localStorage.getItem('currentUser') || 'null');
        const user = stored?.user;
        ru = typeof user === 'string' ? (user || undefined) : (user?._id ?? user?.username ?? user?.email);
      } catch { }
      const queryParams: any = { returnUrl: this.router.url };
      if (ru) { queryParams.ru = ru; }
      this.router.navigate(['/auth/login'], { queryParams });
    }
    return throwError(error);
  }


  postFileToAws<T>(filePath: String, data: {}, fileContent: File | Blob, fileName: string): Observable<AwsRespons> {
    const retObj = new Observable<AwsRespons>((observer) => {
      this.postWithToken('files/' + filePath, data).subscribe(res => {
        const obj = res['params'];
        const formData = new FormData();
        // tslint:disable-next-line:forin
        for (const key in obj) {
          formData.append(key, obj[key]);
        }
        formData.append('file', fileContent, fileName);
        const response: AwsRespons = {
          fileName: res['params']['key'],
          baseUrl: res['endpoint_url'],
        };
        formData.append('content-type', data['type']);

        // .replace("amazonaws.com", "us-west-2.amazonaws.com
        // tslint:disable-next-line:no-shadowed-variable
        this.http.post(res['endpoint_url'], formData, { responseType: 'text', observe: 'events', reportProgress: true }).subscribe(data => {
          switch (data.type) {
            case HttpEventType.UploadProgress:
              response.progress = Math.floor((data.loaded / data.total) * 100)
              response.done = false;
              observer.next(response);
              break;
            case HttpEventType.Response:
              response.done = true;
              observer.next(response);
              break;
          }
          // const keys = data.headers.keys();
          // const headers = keys.map(key =>
          //   `${key}: ${data.headers.get(key)}`);

          // observer.next(response);
        });
      }, err => {
        observer.error(err);
      });

    });
    return retObj;
  }

  downloadFile(url: string): Observable<Blob> {
    const opt = this.getOptions();
    opt['responseType'] = 'blob';
    return this.http.get<Blob>(this.base_url + 'api/files/downloadPdfFromHtml/' + encodeURIComponent(url), opt);
  }

  postBlob(url: string, data: any): Observable<Blob> {
    const opt = this.getOptions();
    opt['responseType'] = 'blob';
    return this.http.post<Blob>(this.base_url + 'api/' + url, data, opt);
  }

  /** getWithToken for a file: the whole blob response, so the caller can read Content-Disposition; an expired session goes to login. */
  getBlobResponse(path: string): Observable<HttpResponse<Blob>> {
    const headers = new HttpHeaders({ 'x-access-token': String(this.authToken || '') });
    return this.http.get(`${this.base_url}api/${path}`, { headers, observe: 'response', responseType: 'blob' }).pipe(
      catchError((error: HttpErrorResponse) => this.handleErrors(error)),
    );
  }

  // Full response variant so callers can read headers (e.g. Content-Disposition).
  postBlobResponse(url: string, data: any): Observable<HttpResponse<Blob>> {
    const opt = this.getOptions();
    opt['responseType'] = 'blob';
    opt['observe'] = 'response';
    return this.http.post(this.base_url + 'api/' + url, data, opt as any) as unknown as Observable<HttpResponse<Blob>>;
  }

  

  // intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //   return next.handle(request).pipe(
  //     map((event: HttpEvent<any>) => event), // pass further respone
  //     catchError((error: HttpErrorResponse) => {
  //       // here will be catched error from response, just check if its 401
  //       if (error && error.status == 401)
  //         // then logout e.g. this.authService.logout()
  //         return throwError(error);
  //     }));
  // }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(
        err =>
          new Observable<HttpEvent<any>>(observer => {
            if (err instanceof HttpErrorResponse) {
              const errResp = <HttpErrorResponse>err;
              if (errResp.status === 401 || err.status === 403) {
                // this.authService.goToLogin();
              }
            }
            observer.error(err);
            observer.complete();
          }),
      ),
    );
  }
}

export interface AwsRespons {
  fileName: string;
  baseUrl: string;
  progress?: number;
  done?: boolean;
}
